import { Badge, Box, Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

/**
 * Intended to display an icon for the request
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellRequestMessageIcon = (classes, props = {}) => {
  const { unreadMessages } = props
  return (
    <Typography
      component={'div'}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
        }}
        className={classes.root}
      >
        <Badge
          color={'signal'}
          badgeContent={unreadMessages}
          sx={{ color: 'white.main' }}
        >
          <Icon
            name={'mail'}
            color={'black'}
          />
        </Badge>
      </Box>
    </Typography>
  )
}

export default CellHOC(ListItemCellRequestMessageIcon)
